import { createSelector } from 'reselect';
import { keyBy, Dictionary, groupBy } from 'lodash';
import PageModel, { PageKind } from '../model/PageModel';
import { StoreState } from '../store-interfaces';
import PageGroupModel from '../model/PageGroupModel';

export const selectPages = (state: StoreState) => state.page.entities || [];
export const selectPageGroups = (state: StoreState): PageGroupModel[] =>
  state.pageGroup.entities || [];

const getDefaultPage = (pages: PageModel[]) => {
  return pages.find(p => p.kind === PageKind.DefaultPage);
};

export const defaultPageSelector = createSelector(
  [selectPages],
  getDefaultPage,
);

export const selectFirstPage = createSelector([selectPages], pages => pages[0]);

export const defaultPageIdSelector = createSelector(
  [defaultPageSelector],
  defaultPage => defaultPage?.id,
);

export const selectPagesDictionary = createSelector(
  [selectPages],
  (pages: PageModel[]) => keyBy(pages, 'id'),
);

// Note: not very clear right now, but we might need to have a custom one to handle
// the situation of pageGroupId being null or undefined.
export const selectPageEntitiesByPageGroupsDictionary = createSelector(
  [selectPages],
  (pages: PageModel[]) => groupBy(pages, 'pageGroupId'),
);

const getPageById = (PagesDict: Dictionary<PageModel>, id: string): PageModel =>
  PagesDict[id];

export const pageEntityByIdSelector = createSelector(
  [selectPagesDictionary, (_: any, id: string) => id],
  getPageById,
);

const getPageByKind = (pages: PageModel[], kind: PageKind) =>
  pages.filter(p => p.kind === kind);

export const selectWelcomePages = createSelector(
  [selectPages, _ => PageKind.WelcomePage],
  getPageByKind,
);

export const selectStartBotPages = createSelector(
  [selectPages, _ => PageKind.StartBot],
  getPageByKind,
);
